import { render, staticRenderFns } from "./calling-plan-type.vue?vue&type=template&id=04d1a9d2&scoped=true"
import script from "./calling-plan-type.vue?vue&type=script&lang=js"
export * from "./calling-plan-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1a9d2",
  null
  
)

export default component.exports